/**
 * #wiki_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { AllowEditorRequest, EditWikiPageRequest, GetWikiPageRequest, GetWikiPageResponse, GetWikiPageRevisionsRequest, GetWikiPageSettingsRequest, GetWikiPagesRequest, GetWikiPagesResponse, GetWikiRevisionsRequest, HideWikiPageRevisionRequest, HideWikiPageRevisionResponse, RevertWikiPageRequest, UpdateWikiPageSettingsRequest, WikiPageRevisionListing, WikiPageSettings, } from "./wiki_msg.js";
export const WikiServiceName = "devvit.plugin.redditapi.wiki.Wiki";
export class WikiClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || WikiServiceName;
        this.rpc = rpc;
        this.GetWikiPages = this.GetWikiPages.bind(this);
        this.GetWikiPage = this.GetWikiPage.bind(this);
        this.EditWikiPage = this.EditWikiPage.bind(this);
        this.HideWikiPageRevision = this.HideWikiPageRevision.bind(this);
        this.GetWikiPageRevisions = this.GetWikiPageRevisions.bind(this);
        this.GetWikiRevisions = this.GetWikiRevisions.bind(this);
        this.RevertWikiPage = this.RevertWikiPage.bind(this);
        this.GetWikiPageSettings = this.GetWikiPageSettings.bind(this);
        this.UpdateWikiPageSettings = this.UpdateWikiPageSettings.bind(this);
        this.AllowEditor = this.AllowEditor.bind(this);
    }
    GetWikiPages(request, metadata) {
        const data = GetWikiPagesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWikiPages", data, metadata);
        return promise.then((data) => GetWikiPagesResponse.decode(_m0.Reader.create(data)));
    }
    GetWikiPage(request, metadata) {
        const data = GetWikiPageRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWikiPage", data, metadata);
        return promise.then((data) => GetWikiPageResponse.decode(_m0.Reader.create(data)));
    }
    EditWikiPage(request, metadata) {
        const data = EditWikiPageRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "EditWikiPage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    HideWikiPageRevision(request, metadata) {
        const data = HideWikiPageRevisionRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "HideWikiPageRevision", data, metadata);
        return promise.then((data) => HideWikiPageRevisionResponse.decode(_m0.Reader.create(data)));
    }
    GetWikiPageRevisions(request, metadata) {
        const data = GetWikiPageRevisionsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWikiPageRevisions", data, metadata);
        return promise.then((data) => WikiPageRevisionListing.decode(_m0.Reader.create(data)));
    }
    GetWikiRevisions(request, metadata) {
        const data = GetWikiRevisionsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWikiRevisions", data, metadata);
        return promise.then((data) => WikiPageRevisionListing.decode(_m0.Reader.create(data)));
    }
    RevertWikiPage(request, metadata) {
        const data = RevertWikiPageRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RevertWikiPage", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    GetWikiPageSettings(request, metadata) {
        const data = GetWikiPageSettingsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWikiPageSettings", data, metadata);
        return promise.then((data) => WikiPageSettings.decode(_m0.Reader.create(data)));
    }
    UpdateWikiPageSettings(request, metadata) {
        const data = UpdateWikiPageSettingsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateWikiPageSettings", data, metadata);
        return promise.then((data) => WikiPageSettings.decode(_m0.Reader.create(data)));
    }
    AllowEditor(request, metadata) {
        const data = AllowEditorRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AllowEditor", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
}
export const WikiDefinition = {
    name: "Wiki",
    fullName: "devvit.plugin.redditapi.wiki.Wiki",
    methods: {
        /**
         * Get a list of wiki pages for a subreddit
         *
         * @see {@link https://www.reddit.com/dev/api#GET_wiki_pages}
         */
        getWikiPages: {
            name: "GetWikiPages",
            requestType: GetWikiPagesRequest,
            requestStream: false,
            responseType: GetWikiPagesResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            112,
                            97,
                            103,
                            101,
                            115,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * Get a wiki page
         *
         * @see {@link https://www.reddit.com/dev/api#GET_wiki_\{page\}}
         */
        getWikiPage: {
            name: "GetWikiPage",
            requestType: GetWikiPageRequest,
            requestStream: false,
            responseType: GetWikiPageResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            44,
                            18,
                            42,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            123,
                            112,
                            97,
                            103,
                            101,
                            125,
                            63,
                            118,
                            61,
                            123,
                            114,
                            101,
                            118,
                            105,
                            115,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * Edit wiki page
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_wiki_edit}
         */
        editWikiPage: {
            name: "EditWikiPage",
            requestType: EditWikiPageRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            30,
                            18,
                            28,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            101,
                            100,
                            105,
                            116,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * Hide a wiki page revision
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_wiki_hide}
         */
        hideWikiPageRevision: {
            name: "HideWikiPageRevision",
            requestType: HideWikiPageRevisionRequest,
            requestStream: false,
            responseType: HideWikiPageRevisionResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            30,
                            18,
                            28,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            104,
                            105,
                            100,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Get a list of revisions of a wiki page
         *
         * @see {@link https://www.reddit.com/dev/api#GET_wiki_revisions_\{page\}}
         */
        getWikiPageRevisions: {
            name: "GetWikiPageRevisions",
            requestType: GetWikiPageRevisionsRequest,
            requestStream: false,
            responseType: WikiPageRevisionListing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            131,
                            1,
                            18,
                            128,
                            1,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            114,
                            101,
                            118,
                            105,
                            115,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            112,
                            97,
                            103,
                            101,
                            125,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            115,
                            114,
                            95,
                            100,
                            101,
                            116,
                            97,
                            105,
                            108,
                            61,
                            123,
                            115,
                            114,
                            95,
                            100,
                            101,
                            116,
                            97,
                            105,
                            108,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * Retrieve a list of recently changed wiki pages in this subreddit
         *
         * @see {@link https://www.reddit.com/dev/api#GET_wiki_revisions}
         */
        getWikiRevisions: {
            name: "GetWikiRevisions",
            requestType: GetWikiRevisionsRequest,
            requestStream: false,
            responseType: WikiPageRevisionListing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            123,
                            18,
                            121,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            114,
                            101,
                            118,
                            105,
                            115,
                            105,
                            111,
                            110,
                            115,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            115,
                            114,
                            95,
                            100,
                            101,
                            116,
                            97,
                            105,
                            108,
                            61,
                            123,
                            115,
                            114,
                            95,
                            100,
                            101,
                            116,
                            97,
                            105,
                            108,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /**
         * Revert a wiki page to revision
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_wiki_revert}
         */
        revertWikiPage: {
            name: "RevertWikiPage",
            requestType: RevertWikiPageRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            114,
                            101,
                            118,
                            101,
                            114,
                            116,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Retrieve the current permission settings for page
         *
         * @see {@link https://www.reddit.com/dev/api#GET_wiki_settings_\{page\}}
         */
        getWikiPageSettings: {
            name: "GetWikiPageSettings",
            requestType: GetWikiPageSettingsRequest,
            requestStream: false,
            responseType: WikiPageSettings,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            115,
                            101,
                            116,
                            116,
                            105,
                            110,
                            103,
                            115,
                            47,
                            123,
                            112,
                            97,
                            103,
                            101,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update the permissions and visibility of wiki page
         *
         * @see {@link https://www.reddit.com/dev/api#POST_wiki_settings_\{page\}}
         */
        updateWikiPageSettings: {
            name: "UpdateWikiPageSettings",
            requestType: UpdateWikiPageSettingsRequest,
            requestStream: false,
            responseType: WikiPageSettings,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            115,
                            101,
                            116,
                            116,
                            105,
                            110,
                            103,
                            115,
                            47,
                            123,
                            112,
                            97,
                            103,
                            101,
                            125,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Allow/deny username to edit this wiki page
         * Note act must be either "add" or "del"
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_wiki_alloweditor_\{act\}}
         */
        allowEditor: {
            name: "AllowEditor",
            requestType: AllowEditorRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            43,
                            18,
                            41,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            107,
                            105,
                            47,
                            97,
                            108,
                            108,
                            111,
                            119,
                            101,
                            100,
                            105,
                            116,
                            111,
                            114,
                            47,
                            123,
                            97,
                            99,
                            116,
                            125,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
    },
};
